module.exports = __webpack_public_path__ + "img/sign-out-light.2790ccc6.svg";